import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { createSubProduct } from '../../../../../../../../jsx/actions/recyclingAction'

import Photos, { Files } from '../../../../../commonModules/interface/input-files';
import InputText, { InputSelectNative, TextArea } from '../../../../../commonModules/interface/form-input-inline.jsx';
import { isEmpty, size } from "lodash"
import { Grid, TextField, Typography, Button, Box, Card, CardHeader, CardActions } from '@material-ui/core';
import { GroupCheckbox, GroupRadio, SingleCheckbox, SingleRadio } from '../../../../../commonModules/MUI/RadioAndCheckbox';
import { toast } from 'react-toastify';
import CardFormLayout from '../../containers/CardFormLayout';

export const BIN_TYPES = {
    "panneaux": "Panneaux Solaires",
    "plastic": "Plastique",
    "electronics": "Dechet Électroniques",
    "lithium": "Batteries Lithium",
    "plomb": "Batteries Plomb",
    "cable": "Cable",
    "other": "Tout Venant",
}

class FormSubProduct extends Component {
    state = {
        update: this.props.update,
        sending: false,
        photos:{},
        
        product: {
            name: "",
            // marque: "",
            // product_type: "",
            quantity: "",

            photos: [],
            datasheets: [],

            longueur: "",
            largeur: "",
            hauteur: "",
            poids: "",
            bin_type: ""
        },
        errors:{
            name: "",
            // marque: "",
            // product_type: "",
            quantity: "",

            photos: [],
            datasheets: [],

            longueur: "",
            largeur: "",
            hauteur: "",
            poids: "",
            bin_type: ""
        },

        floatFields: [
            "poids",
        ],
        intFields : [
            "longueur",
            "largeur",
            "hauteur",
            "quantity",
        ],

    }

    componentDidMount = () => {
        const { product } = this.state;
        if(this.props.product){
            let newProd = Object.assign({}, product, this.props.product)
    
            console.log('====================================');
            console.log({product, newProd});
            console.log('====================================');
    
            this.setState({  product: newProd})
        }
    }
    createBinList(){ 
        return Object.keys(BIN_TYPES).map((key) => {
            return (        
                <option key={key} value={key} >{BIN_TYPES[key]}</option>
            )
        })
    }

    handleChange = (e) => { 
        const field = e.target.name
        const value = e.target.value
        const regex = /^[+]?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        const regex2 = /^[0-9\b]+$/ // int only
        const {floatFields, intFields} = this.state

        console.log({e, field, value});

        if(floatFields.includes(field)){
            if( value === "" || regex.test(value) ){// update value only if its a int || float
                this.setState({
                    ...this.state,
                    product:{
                        ...this.state.product,
                        [field]:value
                    }
                })
                
            }
        } else if( intFields.includes(field)) {
            if(value === "" || regex2.test(value)){// update value only if its an int
                this.setState({
                    ...this.state,
                    product:{
                        ...this.state.product,
                        [field]:value
                    }
                })
            }
        // } else if(this.state.update && noUpdate.includes(field)){
        //     this.setState({// don't change on update 
        //         ...this.state,
        //         product:{
        //             ...this.state.product
        //         }
        //     })
        } else {
            this.setState({
                ...this.state,
                product:{
                    ...this.state.product,
                    [field]:e.target.value
                }
            })

        }
    }

    setPhotos = (list) => {
        console.log("[INFO] SETPHOTOS", list);
        
        this.setState({
            ...this.state,
            product:{
                ...this.state.product,
                photos:list
            }
        })
    }
    setFiles = (list) => {
        console.log("[INFO] SET FILES", list);
        
        this.setState({
            ...this.state,
            product:{
                ...this.state.product,
                datasheets:list
            }
        })
    }

    validate = () => {//check form data before submit
        let noErrors = true
        let errors = {}

        const common = [
            "name",
            // "marque",
            // "product_type",
            "quantity",
            "poids",
            "longueur",
            "largeur",
            "hauteur", 
            "bin_type"
        ]

        Object.keys(this.state.product).map( field => {
            if(this.state.product[field] === "" || this.state.product[field] === []){// input is empty  
                
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"

            } else {// no error
                errors[field] = ""   
            }
        })
        
        console.log("[INFO] NOERRORS = ", noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ", errors);
        
        this.setState({
            ...this.state,
            errors : errors
        })
        return noErrors
    }

    handleSubmit = async () => {
        if( this.validate()){
            const newProd = Object.assign({},this.state.product)
            newProd.id = ""
            newProd.product_id = this.props.MAIN_PRODUCT_ID

            const { floatFields, intFields } = this.state

            floatFields.map( field => {
                newProd[field] = parseFloat(newProd[field])
            })
            intFields.map( field => {
                newProd[field] = parseInt(newProd[field])
            })

            // newProd.ref = this.createRef()
                
            console.log(newProd);
                
            await this.props.createSubProduct(newProd)
                
            if(this.props.STATE.products.error){
                console.log("ERROR", this.props.STATE.products.error);
                this.setState({
                    sending: false,
                })
                toast.error( this.props.STATE.products.error)
            } else{
                console.log("fetched");
                //success 
                this.setState({
                    sending: false,
                })
                toast.info("Le sous produit a été créé avec succès")
                this.props.handleCloseForm()
            }
        } else {
            toast.error( "Le formulaire contient des erreurs")
            this.setState({
                sending: false,
            })
        }
    }
    handleSubmitUpdate = async () => {
        if( this.validate()){
            const newProd = Object.assign({},this.props.product, this.state.product)
            const {floatFields, intFields} = this.state
            
            floatFields.map( field => {
                newProd[field] = parseFloat(newProd[field])                
            })
            intFields.map( field => {
                newProd[field] = parseInt(newProd[field])
            })
            
            await this.props.updateSubProduct(newProd)

            if(this.props.STATE.products.error){
                console.log("ERROR", this.props.STATE.products.error);
                toast.error( this.props.STATE.products.error)
            } else{
                console.log("Product updated")
                //success 
                toast.info("Le produit a été modifié avec succès")
                
                this.props.handleCloseForm()
            }

        } else {
            toast.warning( "le formulaire contient des erreurs" )
        }
    }

    render() {
        const submit = (
            <Button 
                disabled={this.state.sending || this.props.STATE.products.fetching} 
                className="confirm"
                color="secondary"
                variant="contained"
                // style={{ display: "inline-block" }} 
                onClick={this.handleSubmit}
            >
                Ajouter
            </Button>
        )
        const submitUpdate = (
            <Button 
                disabled={this.state.sending || this.props.STATE.products.fetching}     
                className="confirm"
                color="secondary"
                variant="contained" 
                onClick={this.handleSubmitUpdate}
            >
                {this.props.duplicate ? "Dupliquer" : "Modifier"}
            </Button>
        )
        console.log(this.state.product);
        return (
            <CardFormLayout
                title="Nouveau sous produit"
                disabled={this.props.STATE.products.fetching} 
                cancelSubmit={this.props.handleCloseForm}
                submitButton={(this.props.update ? submitUpdate : submit)}
            >
               
               <Box p={1}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <InputText 
                                name="name" 
                                value={this.state.product.name} 
                                error={this.state.errors.name} 
                                change={this.handleChange} 
                                title="Nom" 
                                placeholder="Nom du Produit" 
                                required
                            />
                            
                            <InputSelectNative
                                label="Bac de Recyclage"
                                name="bin_type"
                                value={this.state.product.bin_type}
                                error={this.state.errors.bin_type}
                                change={this.handleChange}
                                required
                                options={this.createBinList()}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextArea 
                                name="product_desc" 
                                value={this.state.product.product_desc} 
                                error={this.state.errors.product_desc} 
                                change={this.handleChange} 
                                title="Description" 
                                required
                                rows={5}
                                placeholder="Description du Produit" 
                            />
                        </Grid>
                    </Grid>
                
                    <Grid container spacing={1} style={{textAlign: "center"}}>
                        <Grid item xs={12} sm={6}>
                            {!this.state.update &&
                            
                                <Photos photoList={this.setPhotos} photos={this.state.product.photos === null ? [] : this.state.product.photos }/>
                            
                            }
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {/* {!this.state.update &&
                            <Box p={1 }>
                                <label className="control-label">Autres Fichiers </label>
                                <div>
                                    <Files photoList={this.setFiles} photos={this.state.product.datasheets === null ? [] : this.state.product.datasheets } file />
                                    </div>
                                    </Box>
                                } */}
                                <Files photoList={this.setFiles} photos={this.state.product.datasheets === null ? [] : this.state.product.datasheets } file />
                        </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <InputText name="poids" value={this.state.product.poids} error={this.state.errors.poids}  change={this.handleChange} title="Poids (g)" required placeholder="Poids en g" />
                        </Grid>
                        <Grid item xs={6}>
                            <InputText required name="quantity" value={this.state.product.quantity} error={this.state.errors.quantity} change={this.handleChange} title="Quantité" placeholder="Quantité" />
                        </Grid>
                    </Grid>
                    
                    <Grid container spacing={1}>
                        {/* <Grid item xs={12}>
                            <Typography variant="subtitle1">Dimensions (LxlxH) *</Typography>
                        </Grid> */}
                        <Grid item xs={12} sm={4}>
                            <InputText
                                change={this.handleChange} 
                                value={this.state.product.largeur} 
                                name="largeur" 
                                title="Largeur (mm)" 
                                required 
                                error={this.state.errors.largeur}
                                type="number"
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={4}>
                            <InputText
                                change={this.handleChange} 
                                value={this.state.product.longueur} 
                                name="longueur" 
                                title="Longueur (mm)" 
                                required 
                                error={this.state.errors.longueur}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputText
                                change={this.handleChange} 
                                value={this.state.product.hauteur} 
                                name="hauteur" 
                                title="Hauteur (mm)" 
                                required 
                                error={this.state.errors.hauteur}
                                type="number"
                            />
                        </Grid>                        
                    </Grid>
                </Box>
            
            </CardFormLayout>
        );
    }
}


function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        PRODUCTS: state.inventory.products,
        STATE: state.inventory.requestState

        // SUB_PRODUCTS: state.inventory.sub_products,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        createSubProduct,
        // updateSubProduct
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(FormSubProduct);